<template>
  <div class="page">
    <div class="item-box">
      <div class="content">
        <div
          class="item"
          v-for="(item, index) in enterpriseServicesRowData"
          :key="index"
          @click="toPage(item)"
        >
          <img :src="item.icon" alt="" />
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
    <van-dialog
      class="reportPosterShow"
      v-model="reportPosterShow"
      close-on-click-overlay
      :showConfirmButton="false"
    >
      <img :src="reportPosterImg" />
    </van-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth.js";
import { getCurrentChannelInfo } from "@/api/login.js";
import { genCompanyRepoPost } from "@/api/product.js";
import { Toast, Dialog } from "vant";
import { xcDepConfig } from "@/api/depConfig.js";
import { getDepNameByDomain } from "@/utils/index";
Vue.use(Toast);
import Vue from "vue";
export default {
  created() {
    this.getDepConfig();
  },
  data() {
    return {
      // 当前平台名称
      depName: "",
      // 企业服务合集
      enterpriseServicesRowData: [
        {
          icon: "https://static.xchengtech.cn/af1d184353624509b0a89488f7de3150.png",
          name: "债务优化",
          url: "https://independentpage.xchengtech.cn/productPage/zwyh.html",
        },
        {
          icon: "https://static.xchengtech.cn/d6f919ef79fc4f729705258f5b9ff8e8.png",
          name: "补贴信息",
          url: "https://independentpage.xchengtech.cn/productPage/czpt.html",
        },
        {
          icon: "https://static.xchengtech.cn/4321b5fbcfb74d38bbf6cbf333ae655a.png",
          name: "资产配置",
          url: "https://independentpage.xchengtech.cn/productPage/zcpz.html",
        },
        {
          icon: "https://static.xchengtech.cn/acfcd1583a1f40389dc12564debdfbff.png",
          name: "帐户管理",
          url: "https://independentpage.xchengtech.cn/productPage/zhgl.html",
        },
      ],
      reportPosterShow: false,
      reportPosterImg: "",
    };
  },
  methods: {
    getDepConfig() {
      // 判断当前平台
      this.depName = getDepNameByDomain();
    },
    toPage(item) {
      // 判断是否登录
      if (getToken()) {
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        // 获取渠道用户信息
        getCurrentChannelInfo()
          .then((res) => {
            // console.log("res", res);
            this.toUrl(item.url + "?channelId=" + res.id);
          })
          .catch((err) => {
            console.log("err", err);
            Toast.clear();
          });
      } else {
        this.$router.push({
          path: "/login",
        });
      }
    },
    toUrl(url) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      console.log("utl", url);
      window.location.href = url;
      Toast.clear();
    },
  },
};
</script>
<style scoped>
/* 图标 */
/* https://www.iconfont.cn/collections/detail?spm=a313x.collections_index.i1.d9df05512.2de33a81FlhdvO&cid=53271 */
.page {
  padding: 0 4vw;
  /* background-color: #f7f7f9; */
}
.title {
  display: flex;
  align-items: center;
  gap: 2vw;
}
.title span:nth-of-type(1) {
  display: inline-block;
  height: 3vw;
  width: 4px;
  background-color: #2841c1;
  border-radius: 4px;
}
.title span:nth-of-type(2) {
  font-size: 4.2vw;
  font-weight: 600;
}
.item-box {
  /* background: white; */
  /* border-radius: 14px; */
  padding: 6vw 0 4vw 0;
  display: grid;
  gap: 4vw;
}
.item-box .content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2vw;
  grid-row-gap: 4vw;
}
.item-box .content:nth-of-type(2) {
}
.item-box .item {
  display: grid;
  text-align: center;
  font-size: 3.2vw;
  gap: 2vw;
  font-weight: 600;
}

.item-box .item img {
  display: block;
  height: 6vw;
  margin: 0 auto;
}
.reportPosterShow {
  border-radius: 0;
}
.reportPosterShow img {
  display: block;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/productList/module/funSummary.vue